import i18n from '@/plugins/i18n';

export const selectRules = [v => !!v || i18n.t('choose_one_option')];
export const nameRules = [v => !!v || i18n.t('name_is_required')];
export const noEmptyStringRules = [v => !!v || 'is required'];
export const positiveIntegerWithZeroRule = [v => (!isNaN(v) && v !== '' && v >= 0 && v % 1 == 0) || i18n.t('not_valid_positive_integer_zero_valid')];
export const positiveNumberWithZeroIncludedRule = [v => (v >= 0 && !isNaN(v)) || 'need positive number (0 is valid)'];
export const emailRule = [v => (v.length != 0 && validateEmail(v)) || i18n.t('modal_share_maintenance_email_error')];
export const unitNotEmptyRule = [v => v.length > 0 || i18n.t('unit_must_be_selected')];
export const integerPositiveRule = [v => (!isNaN(v) && v !== '' && v > 0 && v % 1 == 0) || i18n.t('not_valid_number')];
export const integerRule = [v => (!isNaN(v) && v !== '') || i18n.t('not_valid_positive_integer')];
export const needToBeChecked = [v => !!v || 'Need to be confirmed'];

function validateEmail(email) {
  var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  return re.test(String(email).toLowerCase());
}
